export default __webpack_public_path__ + "static/media/TemplateBookbank.1a3da7ef.xlsx";